export enum ContentTypeEnum {
  ApplicationJSON = 'application/json',
  MultipartForm = 'multipart/form-data',
}
